import React from 'react';
import { LoaderContainer, LoaderSpan } from './Loading.style';

export const Loading: React.FunctionComponent = () => {
  return (
    <LoaderContainer>
      <LoaderSpan/>
    </LoaderContainer>
  );
};
export default Loading;
